/** List of hostnames considered as live environments. */
const liveHostnames = ['preview.cometchat.com', 'localhost'];

/** Type definition for builder constants. */
type BuilderConstants = {
  /** The domain URL for the dashboard. */
  dashboardDomain: string;
};

/**
 * Determines whether the current environment is a live environment.
 * @returns {boolean} `true` if the hostname matches a live environment, otherwise `false`.
 */
const isLiveEnv = () => {
  return liveHostnames.includes(window.location.hostname);
};

/** Configuration constants for the builder based on the environment. */
let builderConstants: BuilderConstants;

if (isLiveEnv()) {
  builderConstants = {
    dashboardDomain: 'https://app.cometchat.com',
    // dashboardDomain: 'https://appnew.cometchat.com',
  };
} else {
  builderConstants = {
    dashboardDomain: 'https://app.cometchat-staging.com',
  };
}

export default builderConstants;
